<!-- Inner HTML Google data studio -->
<div class="d-flex justify-content-center">
    <iframe width="1400" height="6000" src="https://datastudio.google.com/embed/reporting/f6787ec5-988a-4751-998e-28e2b9d266a7/page/p_re31gcqqpc" frameborder="0" style="border:0" allowfullscreen></iframe>
</div>
